import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { StockListFilters } from '@/modules/stocks/shared';
import { stockListColumns } from '@/modules/stocks/stock-list/stock-list.column';
import { useStockList } from '@/modules/stocks/stock-list/stock-list.hook';

export const StockList = () => {
    const { data, isLoading, isError, error } = useStockList();
    return (
        <SectionContainer
            isError={isError}
            isLoading={isLoading}
            error={error}
            fallbackPath={Route.DASHBOARD}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb items={[{ label: 'Stocks' }]} />
                        <SectionTitle>All Stocks</SectionTitle>
                    </div>
                    <div>
                        <Link to={Route.PRE_PURCHASE_CREATE}>
                            <Button type={'button'}>Add Stock</Button>
                        </Link>
                    </div>
                </div>
                <StockListFilters searchPlaceholder={'stocks'} />
                <SectionDataTable
                    data={data}
                    columns={stockListColumns}
                    isLoading={isLoading}
                />

                {/*<DataViewer data={data} />*/}
            </Card>
        </SectionContainer>
    );
};

StockList.displayName = 'StockList';
